import React, { useEffect } from "react";
import styles from "./HomeInsurance.module.css";
import Header from "../Header/Header";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import BenefitCard from "../GetQualified/FinancialPreQualification/BenefitCard";
import comprehensiveProtection from "./../../assets/svg/comprehensiveProtection.svg";
import FastEasyQuotes from "./../../assets/svg/Fast&EasyQuotes.svg";
import TrustedProviders from "./../../assets/svg/TrustedProviders.svg";
import config from "../../config";
const benefits = [
    {
        iconSrc: comprehensiveProtection,
        title: "Comprehensive Protection",
        description: "Coverage that fits your property and lifestyle.",
    },
    {
        iconSrc: FastEasyQuotes,
        title: " Fast & Easy Quotes",
        description: "Get personalized offers in minutes.",
    },
    {
        iconSrc: TrustedProviders,
        title: "Trusted Providers",
        description: "Work with top-rated insurance companies.",
    },
];
function HomeInsurance() {
    const navigate = useNavigate(); // Initialize useNavigate

    const handleButtonClick = () => {
        navigate("/services/insurance-quote/step-1"); // Redirect to the specified path
    };
    useEffect(() => {
        document.title = `Insurance Service | ${config.get("COMPANY_NAME")}`;
    }, []);

    return (
        <div className={`${styles.container} tw-w-[100%] tw-justify-center tw-bg-background_color`}>
            <Header title="Apply For Insurance" />
            <main className={`${styles.mainContent} tw-overflow-y-auto`}>
                {/* <img
                    loading="lazy"
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/0bbafeda80572fe08294a1d09a0d5e5d56d369a649532326f010c638f91f9cd4?placeholderIfAbsent=true&apiKey=355710932fa240f1a51c362a9b36f625"
                    alt=""
                    className={styles.backgroundImage}
                /> */}
                <div></div>
                <section className={`${styles.contentWrapper}  px-3  `}>
                    <div className={styles.titleSection}>
                        <h2 className={styles.mainTitle}>Protect Your Dream Home!</h2>
                        <p className={styles.subtitle}>Get personalized insurance quotes tailored to your new property in minutes.</p>
                    </div>
                    <div className={styles.benefitsContainer}>
                        {benefits.map((benefit, index) => (
                            <BenefitCard key={index} {...benefit} />
                        ))}
                    </div>
                    <div className="tw-w-full tw-flex tw-justify-center">
                        <p className="tw-px-3 tw-text-center max-sm:tw-text-justify tw-mt-8 tw-w-[80%] max-sm:tw-w-full">
                            Your home is more than just a place it’s your most valuable asset. Secure it with the right coverage from top-rated
                            insurers, offering competitive quotes customized to your needs.
                        </p>
                    </div>
                    <div className={styles.ctaWrapper}>
                        <button onClick={handleButtonClick} className={`tw-p-[23px] tw-rounded-md tw-bg-primary hover:tw-bg-primary_hover`}>
                            <div className={styles.ctaContent}>
                                <span className={`${styles.ctaText} tw-font-normal`}>Secure Your Home Now</span>
                            </div>
                        </button>
                    </div>
                </section>
                <footer className={styles.footerWrapper}>
                    <p className={styles.footerText}>Your information is safe and secure with us.</p>
                    <a onClick={() => navigate("/privacy-policy")} className={styles.footerLink}>
                        Learn more about our privacy policy
                    </a>
                </footer>
            </main>
        </div>
    );
}

export default HomeInsurance;
